import { z } from 'zod';
import { MakeUploadFormData } from './projectMake.d';

// eslint-disable-next-line import/prefer-default-export
export const makeUploadSchema = z
  .object({
    images: z.array(z.string()).min(1, {
      message: 'At least one image is required',
    }),
    selectedPrinter: z.string().min(1, {
      message: 'Please select a machine',
    }),
    didCutProject: z.enum(['yes', 'no'], {
      required_error: 'Please select whether you cut this project',
    }),
    ratings: z
      .object({
        cutExpectation: z
          .number()
          .min(1, {
            message: 'Please rate cut expectation',
          })
          .max(5),
        cutQuality: z
          .number()
          .min(1, {
            message: 'Please rate cut quality',
          })
          .max(5),
        correctFileInfo: z
          .number()
          .min(1, {
            message: 'Please rate correct file information',
          })
          .max(5),
        coolFactor: z
          .number()
          .min(1, {
            message: 'Please rate cool factor',
          })
          .max(5),
      })
      .optional(),
    caption: z.string().optional(),
  })
  .superRefine((data, ctx) => {
    if (data.didCutProject === 'yes') {
      if (!data.ratings) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Ratings are required when you cut the project',
          path: ['ratings'],
        });
        return;
      }

      const ratingValues = Object.values(data.ratings);
      if (ratingValues.some((rating) => rating === 0)) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message:
            'All rating criteria must be filled when you cut the project',
          path: ['ratings'],
        });
      }
    }
  }) satisfies z.ZodType<MakeUploadFormData>;
